<template>
  <div class="basic_level_page" :style="{ textAlign: $store.state.isMirroring ? 'right' : 'left' }">
    <Tabbar :title="fromSidebar ? $t('basicLevel.identityVerification') : $t('basicLevel.withdrawTitle')" />
    <div v-if="fromSidebar" class="verify_tabs">
      <div class="verify_tab active">{{ $t('account.basicTab') }}</div>
      <div class="verify_tab" @click="goAdvanced">{{ $t('account.advancedTab') }}</div>
    </div>
    <div v-else class="withdraw_stepper">
      <div class="stepper_line"></div>
      <div class="stepper_item">
        <img class="stepper_icon" src="@/assets/basicLevel/step_done.svg" alt="" />
        <div class="stepper_label active">{{ $t('basicLevel.identityVerification') }}</div>
      </div>
      <div class="stepper_item">
        <div class="stepper_pending">
          <img class="stepper_icon" src="@/assets/basicLevel/step_pending.svg" alt="" />
          <span>2</span>
        </div>
        <div class="stepper_label">{{ $t('basicLevel.withdrawalAccountStep') }}</div>
      </div>
    </div>
    <div class="page_body">
      <div class="form_list">
        <div class="fill_hint">{{ $t('basicLevel.fillInfoHint') }}</div>
        <Tip :content="$t('basicLevel.basicLevelNote')" />
        <CommonFormItem
          class="form_item"
          :label="$t('common.firstName')"
          :note="$t('basicLevel.nameMatchNote')"
          required
        >
          <CommonInput
            v-model="firstName"
            theme="white"
            :placeholder="$t('basicLevel.nameFieldPlaceholder')"
            :onInput="($event) => validateInput($event, 1)"
          >
            <img v-if="firstName" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
        <CommonFormItem class="form_item" :label="$t('common.middleName')">
          <CommonInput
            v-model="middleName"
            theme="white"
            :placeholder="$t('basicLevel.nameFieldPlaceholder')"
            :onInput="($event) => validateInput($event, 2)"
          >
            <img v-if="middleName" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
        <CommonFormItem
          class="form_item"
          :label="$t('common.lastName')"
          :required="$store.state.userInfo.countryNo !== 91"
        >
          <CommonInput
            v-model="lastName"
            theme="white"
            :placeholder="$t('basicLevel.nameFieldPlaceholder')"
            :onInput="($event) => validateInput($event, 3)"
          >
            <img v-if="lastName" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
        <CommonFormItem class="form_item gender_item" :label="$t('common.gender')" required>
          <div class="radio_group">
            <div :class="gender === 1 && 'selected'" class="gender_radio_btn" @click="gender = 1">
              <img v-show="gender === 1" class="selected_icon" src="@/assets/icon_check_select_green.png" alt="" />
              <img v-show="gender !== 1" class="selected_icon" src="@/assets/icon_check_normal_green.png" alt="" />
              {{ $t('common.female') }}
            </div>
            <div :class="gender === 0 && 'selected'" class="gender_radio_btn" @click="gender = 0">
              <img v-show="gender === 0" class="selected_icon" src="@/assets/icon_check_select_green.png" alt="" />
              <img v-show="gender !== 0" class="selected_icon" src="@/assets/icon_check_normal_green.png" alt="" />
              {{ $t('common.male') }}
            </div>
          </div>
        </CommonFormItem>
        <CommonFormItem class="form_item" :label="$t('common.birthday')" required>
          <div class="field_with_check">
            <SelectDate
              v-model="birthday"
              :placeholder="$t('basicLevel.birthdayPlaceholder')"
              :defaultDate="before18Date"
              :defaultMaxDate="before18Date"
            />
            <img v-if="birthday" class="field_check overlay" src="@/assets/icon_check_select_green.png" alt="" />
          </div>
        </CommonFormItem>
        <CommonFormItem class="form_item" :label="$t('common.email')" :required="!$store.state.userInfo.email">
          <div class="email_area">
            <div class="email_input_box">
              <input
                class="email_input_area email"
                :class="[$store.state.isMirroring && 'mirror']"
                v-model="email"
                type="text"
                :placeholder="$t('common.email')"
                autocomplete="off"
                :disabled="!!$store.state.userInfo.email"
              />
              <img
                v-if="email"
                class="email_input_icon"
                src="@/assets/icon_check_select_green.png"
                alt=""
              />
            </div>
          </div>
        </CommonFormItem>
        <CommonFormItem class="form_item" :label="$t('common.address')" required>
          <CommonInput v-model="address" theme="white" :placeholder="$t('basicLevel.addressPlaceholder')">
            <img v-if="address" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
      </div>
      <div class="bottom_btn_box">
        <CommonBtn
          class="confirm_btn"
          :disabled="!canSubmit"
          :text="$t('common.confirm')"
          :onClick="updateBasicInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import { Dialog, Toast } from 'vant'
import SelectDate from '@/components/SelectDate'
import moment from 'moment'
import CommonFormItem from '@/components/CommonFormItem.vue'
import CommonInput from '@/components/CommonInput.vue'
import CommonBtn from '@/components/CommonBtn.vue'
import Tip from '@/components/LinkAccount/Tip.vue'

export default {
  name: 'EditBasicLevel',
  components: {
    Tabbar,
    SelectDate,
    CommonFormItem,
    CommonInput,
    CommonBtn,
    Tip
  },
  data() {
    return {
      firstName: this.$store.state.userInfo.firstName,
      middleName: this.$store.state.userInfo.middleName,
      lastName: this.$store.state.userInfo.lastName || '',
      birthday: this.$store.state.userInfo.birthday,
      gender: this.$store.state.userInfo.gender,
      address: this.$store.state.userInfo.address,
      email: this.$store.state.userInfo.email || '',
      before18Date: moment().subtract(18, 'years').format('YYYY-MM-DD')
    }
  },
  computed: {
    userLevel() {
      return this.$store.state.userInfo.level
    },
    fromSidebar() {
      return this.$route.query.from === 'sidebar'
    },
    canSubmit() {
      const filled = (value) => !!(value && String(value).trim())
      const lastNameOk = this.$store.state.userInfo.countryNo === 91 || filled(this.lastName)
      const genderOk = this.gender === 0 || !!this.gender
      const emailOk = this.$store.state.userInfo.email ? true : filled(this.email)
      return (
        filled(this.firstName) &&
        lastNameOk &&
        genderOk &&
        filled(this.birthday) &&
        filled(this.address) &&
        emailOk
      )
    }
  },
  methods: {
    goAdvanced() {
      this.$router.replace({ name: 'FullyVerified', query: { ...this.$route.query } })
    },
    validateInput(event, type) {
      const inputValue = event.target.value
      const regex = /^[a-zA-Z]+$/
      this.$nextTick(() => {
        if (!regex.test(inputValue)) {
          switch (type) {
            case 1:
              this.firstName = inputValue.replace(/[^a-zA-Z]/g, '')
              break
            case 2:
              this.middleName = inputValue.replace(/[^a-zA-Z]/g, '')
              break
            case 3:
              this.lastName = inputValue.replace(/[^a-zA-Z]/g, '')
              break
          }
        }
      })
    },
    checkBirthday() {
      if (moment(this.birthday) >= moment()) {
        Toast({
          message: this.$t('basicLevel.birthdayFormatToast')
        })
        return false
      }
      return true
    },
    checkRequired() {
      if (
        !this.firstName ||
        (!this.gender && this.gender !== 0) ||
        !this.birthday ||
        !this.address ||
        (!this.$store.state.userInfo.email && !this.email)
      ) {
        Toast({ message: this.$t('basicLevel.fieldEmptyToast') })
        return false
      }
      return true
    },
    updateBasicInfo() {
      if (!this.canSubmit) return
      if (!(this.checkRequired() && this.checkBirthday())) return
      const params = {
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName || '',
        birthday: this.birthday,
        gender: this.gender,
        address: this.address
      }
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur()
      }
      Dialog.confirm({
        title: this.$t('common.attention'),
        message: this.$t('basicLevel.confirmDialog'),
        cancelButtonText: this.$t('common.modify'),
        confirmButtonText: this.$t('common.confirm')
      }).then(() => {
        this.$http.post(window.serverPath + '/api/user/updateBasic', params).then((res) => {
          if (res.data.code === '200') {
            this.$store.commit('setUserInfo', res.data.data)
            Toast.success({
              message: this.$t('basicLevel.successToast')
            })
            this.$router.replace({ name: 'Home' })
          } else if (res.data.code === '60011') {
            Toast(res.data.message)
          } else {
            Toast({
              message: this.$t('basicLevel.failToast')
            })
          }
        })
      })
    }
  },
  mounted() {
    if (this.userLevel < 1) {
      this.$router.replace({ name: 'BasicLevel', query: { ...this.$route.query } })
      return
    }
    this.$http.get(window.serverPath + '/api/user/getBasicUpdateStatus').then((res) => {
      if (!res.data || res.data.code !== '200' || res.data.data !== 1) {
        this.$router.replace({ name: 'SemiVerified', query: { ...this.$route.query } })
      }
    })
  }
}
</script>

<style scoped>
.basic_level_page {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  scrollbar-width: none;
}

.basic_level_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.verify_tabs {
  display: flex;
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #efefef;
}

.verify_tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.08rem 0;
  color: #828282;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  border-bottom: 0.02rem solid transparent;
  margin-bottom: -0.01rem;
  box-sizing: border-box;
}

.verify_tab.active {
  color: #3fbb70;
  border-bottom-color: #3fbb70;
}

.withdraw_stepper {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 0.16rem 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0.04rem 0.02rem rgba(224, 224, 224, 0.25);
}

.stepper_line {
  position: absolute;
  top: calc(0.16rem + 0.115rem);
  left: 25%;
  width: 50%;
  z-index: 0;
  border-top: 0.01rem dashed #dadada;
  pointer-events: none;
}

.stepper_item {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.09rem;
  min-width: 0;
}

.stepper_icon {
  width: 0.23rem;
  height: 0.23rem;
  display: block;
}

.stepper_pending {
  position: relative;
  width: 0.23rem;
  height: 0.23rem;
}

.stepper_pending span {
  position: absolute;
  left: 0;
  right: 0;
  top: 0.025rem;
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 600;
  line-height: 0.18rem;
  text-align: center;
}

.stepper_label {
  width: 100%;
  padding: 0 0.12rem;
  box-sizing: border-box;
  color: #dadada;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 500;
  line-height: 0.18rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stepper_label.active {
  color: #1ba47a;
}

.page_body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.16rem;
  padding: 0.16rem 0.16rem 0.24rem;
  box-sizing: border-box;
}

.fill_hint {
  width: 100%;
  margin-bottom: 0.12rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.2rem;
}

.form_list {
  width: 100%;
}

.form_item {
  margin-bottom: 0.18rem;
}

.form_item.gender_item {
  margin-bottom: 0.16rem;
}

.form_item:last-child {
  margin-bottom: 0;
}

.field_check {
  width: 0.14rem;
  height: 0.14rem;
  flex-shrink: 0;
  margin-inline-start: 0.08rem;
}

.field_with_check {
  position: relative;
}

.field_check.overlay {
  position: absolute;
  top: 50%;
  inset-inline-end: 0.16rem;
  margin-inline-start: 0;
  transform: translateY(-50%);
  pointer-events: none;
}

.radio_group {
  width: 100%;
  display: flex;
  align-items: center;
}

.gender_radio_btn {
  width: 100%;
  height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #d6d6d6;
  color: #aaa;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
}

.gender_radio_btn.selected {
  border: 0.01rem solid #3fbb70;
  color: #41c575;
}

.gender_radio_btn:first-child {
  margin-inline-end: 0.16rem;
}

.selected_icon {
  width: 0.14rem;
  height: 0.14rem;
  margin-inline-end: 0.04rem;
}

.email_area {
  width: 100%;
  border-radius: 0.08rem;
  border: 0.01rem solid #d6d6d6;
}

.email_input_box {
  width: 100%;
  padding: 0.1rem 0.16rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 0.48rem;
}

.email_input_area {
  color: #2f2f2f;
  font-size: 0.14rem;
  line-height: 0.14rem;
  text-align: left;
  height: 0.48rem;
  background: transparent;
  width: 100%;
  caret-color: #3fbb70;
  font-weight: 600;
}

.email_input_area.email {
  direction: ltr;
}

.email_input_area.mirror {
  text-align: right;
}

.email_input_area::placeholder {
  color: #828282;
  font-weight: 400;
}

.email_input_icon {
  width: 0.14rem;
  height: 0.14rem;
}

.bottom_btn_box {
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.confirm_btn {
  width: 100% !important;
  font-size: 0.16rem !important;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9) !important;
}

.confirm_btn.disabled {
  background: #c6c6c6 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/EditBasicLevel.vue